// extracted by mini-css-extract-plugin
export default {"button":"CleanButton__button___ipNW9","icon":"CleanButton__icon___lLLwe"};